import { Link } from 'react-router-dom';
import mascot from '../img/practikay-mascot.svg';

export default function SiteHeader() {
  return (
    <header className="legal-header">
      <div className="content-well">
        <div className="hero-topbar">
          <Link to="/" className="hero-brand" aria-label="Go to home">
            <img className="gradient-mascot" src={mascot} alt="" />
            <div className="hero-brand-text">
              <p className="hero-title">Pratikay</p>
            </div>
          </Link>
          <p className="hero-subtitle hero-subtitle-right">Speak. More. Fluently.</p>
        </div>
      </div>
    </header>
  );
}
